import { gql } from '@/__generated__';

export const REMOVE_GATE_LINKED_DEVICE = gql(`#graphql
  mutation RemoveGateLinkedDevice($input: RemoveGateLinkedDeviceInput!) {
    removeGateLinkedDevice(input: $input) {
      id
      upstreamDevice {
        id
        profile {
          id
          name
        }
      }
      downstreamDevice {
        id
        profile {
          id
          name
        }
      }
    }
  }
`);
